<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			<ng-container *ngIf="buttonLabel === 'Save'">{{order?.number}} - {{order?.project?.name}}</ng-container>
			<ng-container *ngIf="buttonLabel === 'Create'">Create New Order</ng-container>
			<ng-container *ngIf="buttonLabel === 'Confirm'">{{order?.number}} | {{order?.project?.name}}</ng-container>
			<ng-container *ngIf="buttonLabel === 'Accept'">{{order?.number}} | {{order?.project?.name}}</ng-container>
		</span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>


<div class="edit-block">

  <ng-container *ngIf="projectsLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </ng-container>

  <form #userEditForm="ngForm" *ngIf="!projectsLoading">
    <div class="form-block">
      <div class="form-row" *ngIf="buttonLabel !== 'Accept' && buttonLabel !== 'Confirm'">
        <p-dropdown [ngModelOptions]="{standalone: true}" [options]="shortProjects"
                    [(ngModel)]="selectedShortProj" optionLabel="name" placeholder="Project" [required]="true"
                    (onChange)="projectIsChoosen()" [virtualScroll]="true" [itemSize]="31" [filter]="true"
                    filterBy="name,number">
        </p-dropdown>
      </div>
      <div class="form-row" *ngIf="buttonLabel !== 'Accept' && buttonLabel !== 'Confirm'">
        <p-dropdown [ngModelOptions]="{standalone: true}" [options]="vendors" [(ngModel)]="selectedVendor"
                    optionLabel="name" placeholder="Vendor" [[required]="true"]="true">
        </p-dropdown>
      </div>

      <div class="form-row" *ngIf="buttonLabel === 'Save' || buttonLabel === 'Confirm'">
        <p-calendar [(ngModel)]="tempOrder.expectedDeliveryDate" view="date" [tabindex]="-1" type="date"
                    readonly="readonly" [touchUI]="true" name="deliveryDate" [showIcon]="true"
                    [ngModelOptions]="{standalone: true}" [readonlyInput]="true" [showOnFocus]="false"
                    [icon]="'pi pi-calendar'" placeholder="Expected Delivery" (onShow)="blurActiveElement()">
        </p-calendar>
      </div>

      <div class="form-row listbox-row">
        <!-- <ng-container *ngIf="!showMaterials">
          <lib-progress-spinner *ngIf="loadingSpinner"></lib-progress-spinner>
        </ng-container> -->

        <ng-container *ngIf="buttonLabel !== 'Accept' && buttonLabel !== 'Confirm'">
          <p-listbox #listBox [options]="projectMaterials" [(ngModel)]="selectedMaterials" [multiple]="true"
                     [checkbox]="true" [filter]="true" filterPlaceHolder="Search in Materials" optionLabel="name"
                     (onClick)="onListboxChange($event)" [ngModelOptions]="{standalone: true}"
                     class="p-list-box-block" [required]="true">
            <p-header>
              Order Items
            </p-header>
          </p-listbox>
        </ng-container>

        <ng-container *ngIf="buttonLabel === 'Accept' || buttonLabel === 'Confirm'">
          <p-listbox #listBox [options]="projectMaterials" [(ngModel)]="selectedMaterials" [multiple]="true"
                     [checkbox]="true" [filter]="true" filterPlaceHolder="Search in Project" optionLabel="name"
                     (onClick)="onListboxChange($event)" [ngModelOptions]="{standalone: true}"
                     class="p-list-box-block" [required]="true">
            <p-header>
              Order Items
            </p-header>

            <ng-template let-item let-i="index" pTemplate="item">
              <div class="ui-helper-clearfix materials-block-with-arrows">
                <div class="mat-block-name">{{projectMaterials[i].name}}</div>

                <ng-container *ngIf="selectedMaterials.includes(projectMaterials[i])">
                  <div class="arrows-block" (click)="$event.stopPropagation()">
                    <div class="left-arrow arrow-button" (click)="countMinus(i)">
                      <i class="pi pi-angle-left"></i>
                    </div>
                    <div class="arrow-input-block">
                      <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                             [ngModelOptions]="{standalone: true}"
                             [(ngModel)]="projectMaterials[i].orderedQuantity">
                    </div>

                    <div class="right-arrow arrow-button" (click)="countPlus(i)">
                      <i class="pi pi-angle-right"></i>
                    </div>
                  </div>
                  <div class="backorder-block" (click)="$event.stopPropagation()"
                       *ngIf="buttonLabel === 'Accept' || buttonLabel === 'Confirm'">
                    B/O
                    <p-checkbox [(ngModel)]="projectMaterials[i].backorder" [binary]="true">
                    </p-checkbox>
                  </div>
                </ng-container>
              </div>
            </ng-template>

          </p-listbox>
        </ng-container>

      </div>


      <div class="form-row notes-row">
				<textarea #orderTextArea class="order-text-area" matInput placeholder="Notes" type="text"
                  [(ngModel)]="orderNotes" name="notes" [tabindex]="-1"></textarea>
      </div>

    </div>

    <div class="save-btn-block">

      <button mat-button class="save-btn" (click)="saveOrder()"
              [disabled]=" (!selectedShortProj || !selectedMaterials || selectedMaterials.length < 1) || loadingSpinner"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': (!selectedShortProj || !selectedMaterials || selectedMaterials.length < 1) || loadingSpinner}">

        <span *ngIf="!loadingSpinner">{{buttonLabel}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>
    </div>
  </form>

</div>
